import React from "react";
import MarketingSuggestionIcon from "assets/dataRoom/detail/icon_marketing_suggestion.svg";
import styled from "styled-components";
import { device } from "components/styles";

const MARKETING_TEXT: { [key: string]: string } = {
  NAVER: "네이버",
  YOUTUBE: "유튜브",
  INSTAGRAM: "인스타그램",
};

const MARKETING_STRATEGY: { [key: string]: { [key: string]: string } } = {
  NAVER: {
    BLOG: "네이버 블로그에 주 1회 의료 전문 지식을 공유하는 포스팅을 올리는 건",
    CAFE: "네이버 카페를 개설하고 주기적으로 의료 정보 콘텐츠를 제작하는 건",
    PLACE: "네이버 플레이스에서 영수증 리뷰 이벤트를 진행해보는 건",
  },
  YOUTUBE: {
    CONTENT: "유튜브 채널을 개설하고 주기적으로 의료 정보 콘텐츠를 제작하는 건",
    VIEW: "유튜브 쇼츠로 짧은 의료 팁 영상을 제작하여 업로드하는 건",
    SUBSCRIBER:
      "구독자들의 건강 고민을 주제로 한 Q&A 영상을 정기적으로 업로드하는 건",
  },
  INSTAGRAM: {
    CONTENT: "인스타그램 게시물 업로드 빈도를 높여보는 건",
    FOLLOWER: "인스타그램 광고를 활용해 팔로우 이벤트를 진행해보는 건",
  },
};

const MarketingSuggestBox = ({
  data,
}: {
  data: Pick<
    GetHospitalDetailResponse,
    "districtName" | "recommendMarketingStrategy" | "externalBrandingScoreRank"
  >;
}) => {
  const [channel, strategy] = data.recommendMarketingStrategy.split("_");
  const marketingStrategy = MARKETING_STRATEGY[channel][strategy];

  return (
    <MarketingSuggestContainer>
      <div className="titleContainer">
        <img src={MarketingSuggestionIcon} alt="marketingIcon" />
        <div className="cityRank">
          {data.districtName}
          <span>{data.externalBrandingScoreRank}위</span>
        </div>
      </div>

      <div className="line" />
      <div className="marketingSuggestion">
        상위 랭크된 같은 지역 병원의 경우 {MARKETING_TEXT[channel]} 마케팅에
        집중하고 있어요. <br />
        {marketingStrategy} 어때요?
      </div>
    </MarketingSuggestContainer>
  );
};

export default MarketingSuggestBox;

export const MarketingSuggestContainer = styled.div`
  border-radius: 1.6rem;
  background: #f2f4f7;
  padding: 2rem;
  color: #1d68f9;
  font-size: 1.3rem;
  font-weight: 400;
  line-height: 150%;
  display: flex;
  gap: 1.2rem;
  // height: 8.6rem;
  box-sizing: border-box;
  align-items: center;

  @media all and (${device.mobile}) {
    gap: 1.6rem;
    // height: 12.4rem;
    font-size: 1.4rem;
    font-weight: 400;
    flex-direction: column;
    .line {
      display: none;
    }
  }

  & > .titleContainer {
    display: flex;
    gap: 1.2rem;
    align-items: center;
    justify-content: center;

    @media all and (${device.mobile}) {
      flex-direction: column;
    }

    & > .cityRank {
      font-size: 1.5rem;
      font-weight: 700;
      text-align: center;
      span {
        display: block;
      }
    }
  }

  & > .line {
    background-color: #d8dce5;
    width: 0.2rem;
    height: 2.4rem;

    @media all and (${device.mobile}) {
      height: 8.4rem;
    }
  }

  & > .marketingSuggestion {
    // max-width: 43.8rem;

    @media all and (${device.mobile}) {
      // max-width: 21.6rem;
    }
  }
`;
